// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".blacklist-editor[data-v-029425aa]{display:flex;flex-direction:column;max-width:500px}.save-button[data-v-029425aa]{padding:8px 16px;cursor:pointer}.status-message[data-v-029425aa]{margin-top:8px;color:#444}", ""]);
// Exports
module.exports = exports;
